import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import {formatDate} from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ClinicalExamModel } from 'src/app/models/ClinicalExamModel';
import { ClinicalExamService } from 'src/app/services/ClinicalExamService';
import swal from 'sweetalert2';
import { CompanyModel } from 'src/app/models/CompanyModel';
import { CompanyService } from 'src/app/services/CompanyService';


@Component({
  selector: 'app-clinical-exam-entry',
  templateUrl: './clinical-exam-entry.component.html',
  styleUrls: ['./clinical-exam-entry.component.css']
})
export class ClinicalExamEntryComponent implements OnInit {

patientname = '';

patientcode = '' ;
examdate =formatDate(new Date(), 'yyyy-MM-dd', 'en');
OriginalDate  =formatDate(new Date(), 'yyyy-MM-dd', 'en');
examlocation = '' ;
examperfstatus = '' ;
examnotes = '' ;
examnotestext = '' ;
editorConfigNoToolbar = {
  editable: true,
  spellcheck: true,
  showToolbar: true,  // 🚫 This hides the toolbar
  height: '150px',
  frameElement:true,
  minHeight: '0',
  placeholder: '',
  translate: 'yes',
  defaultParagraphSeparator: '',
  defaultFontName: '',

  toolbarHiddenButtons: []
};
userid = '' ;
username = '' ;
maxCharsPerLine = 60;
examtime  =formatDate(new Date(), 'HH:mm', 'en');
companyList : CompanyModel[]=[];

  @Output() submitClicked = new EventEmitter<any>();

  constructor(public clinicalexam:ClinicalExamModel,
    public dialogRef: MatDialogRef<ClinicalExamEntryComponent>,
    public clinicalexamservice : ClinicalExamService,
    public companyService :CompanyService,
    public storage: LocalStorageService,
    @Inject(MAT_DIALOG_DATA) public data :any,
  ) {

   }

  ngOnInit(): void {
    if (this.storage.retrieve('stgGroup') == '8'){
      this.userid = this.storage.retrieve('stgUserIdId')
    }
    else
    {
    this.userid = this.storage.retrieve('stgUserId')
    };
    this.patientcode = this.storage.retrieve('stgPatientCode');
    this.patientname = this.storage.retrieve('stgPatientName');
    this.examdate =   formatDate(this.storage.retrieve('stgVisitDate'), 'yyyy-MM-dd', 'en');
    this.OriginalDate = formatDate(this.storage.retrieve('stgVisitDate'), 'yyyy-MM-dd', 'en');
    this.retriveCompanyLookupTop();
    this.examlocation = this.storage.retrieve('stgLocation');
   // console.log("Location:",this.examlocation ,"-", this.storage.retrieve('stgLocation'))

    this.RetriveData();
  }


  msgError (){
            swal({
            title: 'Please Enter the Location',
            type: 'error',
            showConfirmButton: false,
            timer: 1500
            });
}
 RetriveData(){
    this.clinicalexamservice.getClinicalExam(this.patientcode, this.examdate,this.userid).subscribe({
      next: (data: ClinicalExamModel) => {
        this.examlocation = data.examlocation;
        this.examdate =formatDate(data.examdate, 'yyyy-MM-dd', 'en');
        this.examperfstatus = data.examperfstatus;
        this.examnotes = data.examnotes;
        this.userid = data.userid;
        this.examtime = formatDate(data.examtime, 'hh:mm aa', 'en');
      },
      error: (error) => {
        // Handle any actual errors here, if needed.  For example:
        console.error("Error fetching nurse assessment:", error);
        // You might also want to display an error message to the user.
      },
      complete: () => {
        // This block executes after a successful completion (even if data is null/undefined).
          if (!this.examlocation) {  // Check if visitlocation is undefined or null.  Could also check for an empty string "" if that's a possibility.
              this.examlocation =  this.storage.retrieve('stgLocation');;
              this.examdate = formatDate(this.OriginalDate, 'yyyy-MM-dd', 'en');
          }
      }
    });
  }
  retriveCompanyLookupTop() {
    this.companyService.getLocationLookupTop('1').subscribe((data: CompanyModel[]) => {

        for (let i = 0; i < data.length; i++) {
          this.companyList[i] = data[i];
        }

      });
  }
  updatePlainText() {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = this.examnotes || '';
    this.examnotestext = tempElement.textContent || '';
  }
  // limitLineLength() {
  //   let lines = this.examnotes.split("\n"); // Split by manual Enter presses
  //   let formattedLines: string[] = [];

  //   for (let line of lines) {
  //     while (line.length > this.maxCharsPerLine) {
  //       formattedLines.push(line.substring(0, this.maxCharsPerLine)); // Add first 30 chars
  //       line = line.substring(this.maxCharsPerLine); // Remove added part
  //     }
  //     formattedLines.push(line); // Add remaining part
  //   }

  //   this.examnotes = formattedLines.join("\n"); // Preserve manual and auto lin
  // }
  limitLineLength() {
    const lines = this.examnotes.split("\n"); // Respect manual line breaks
    const formattedLines: string[] = [];

    for (let line of lines) {
      while (line.length > this.maxCharsPerLine) {
        let breakpoint = this.maxCharsPerLine;
        // Look for the last space before maxCharsPerLine to avoid breaking a word
        const lastSpace = line.lastIndexOf(" ", this.maxCharsPerLine);
        if (lastSpace > -1) {
          breakpoint = lastSpace;
        }
        // Push line up to the breakpoint
        formattedLines.push(line.substring(0, breakpoint).trim());
        // Trim and keep the rest of the line
         line = line.substring(breakpoint).trim();
      }
      formattedLines.push(line);
    }

    this.examnotes = formattedLines.join("\n");
  }
  Save_Data(){

    if(this.patientcode !='0000' || this.patientcode != null ){
    this.examtime  =formatDate(new Date(), 'HH:mm', 'en');
    const str1 = formatDate(this.examdate, 'yyyy-MM-dd', 'en') + 'T' + this.examtime+':00.000Z';

    this.clinicalexam.patientcode= this.patientcode;
    this.clinicalexam.examdate= this.examdate;
    this.clinicalexam.examlocation= this.examlocation;
    this.clinicalexam.examperfstatus= this.examperfstatus;
    this.clinicalexam.examnotes= this.examnotes;

    if (this.storage.retrieve('stgGroup') == '8'){
      this.clinicalexam.userid = this.storage.retrieve('stgUserIdId')
      this.clinicalexam.username= this.storage.retrieve('stgusernamename');
    }
    else
    {
      this.clinicalexam.userid = this.storage.retrieve('stgUserId')
      this.clinicalexam.username= this.storage.retrieve('stgusername');
    };
    // this.clinicalexam.userid= this.storage.retrieve('stguserId');
    // this.clinicalexam.username= this.storage.retrieve('stgusername');

    this.clinicalexam.examtime= str1;
    this.clinicalexamservice.AddClinicalExam(this.clinicalexam).subscribe(data => {
    this.mesgSave();
    this.dialogRef.close();
      },
        error => { alert(error); }
      );
    }
  }

  mesgSave() {
      swal({
      title: 'Your work has been saved',

      type: 'success',
      showConfirmButton: false,

      timer: 1500
      });
    }
  Exit_Data(){
    this.dialogRef.close();
  }
}
